import { createContext } from "react";
import { createDefaultContext } from "../../../helpers/createDefaultContext";
import { FieldError } from "../../FieldErrors/FieldErrors";

export type ComboBoxContextValue = {
  activeDescendantId: string | undefined;
  comboBoxId: string;
  errors?: FieldError;
  filterOptions?: boolean;
  form?: string;
  labelId: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  open: boolean;
  optionsRefs: React.RefObject<Map<string, HTMLLIElement>>;
  setActiveDescendantId: (id: string | undefined) => void;
  setFilterOptions: (filterOptions: boolean) => void;
  setOpen: (open: boolean) => void;
  setValue: (value: string) => void;
  textFieldRef: React.RefObject<HTMLLabelElement | null>;
  value: string;
};

export const ComboBoxContext = createContext<ComboBoxContextValue>(
  createDefaultContext(),
);
